import { Status } from '@enums';
import { Admin } from './admin';
import { BaseModel } from './base.model';

export class ServiceProvider extends BaseModel {
  name: string = '';
  imageUrl: string = '';
  apiKey: string = '';
  status: Status = Status.APPROVED;
  admins?: Admin[] = [];

  constructor(data?: Partial<ServiceProvider>) {
    super();
    Object.assign(this, data);
  }
}


